export default function Skills() {
	return (
		<div className="container mx-auto py-2">
			<h1 className="mb-3 text-5xl">Skills</h1>
			{skills.map(skill => (
				<div key={skill.categoryName} className="mb-5">
					<h2 className="mt-2 text-3xl">{skill.categoryName}</h2>
					<ul className="list-inside list-disc">
						{skill.list.map(name => (
							<li key={name}>{name}</li>
						))}
					</ul>
				</div>
			))}
		</div>
	)
}

const skills = [
	{
		categoryName: 'Languages',
		list: ['JavaScript', 'TypeScript', 'CSS', 'SQL', 'Python'],
	},
	{ categoryName: 'Frontend Frameworks', list: ['ReactJS', 'Django'] },
	{
		categoryName: 'Backend Frameworks',
		list: ['NodeJS', 'ExpressJS', 'Django'],
	},
	{ categoryName: 'FullStack Frameworks', list: ['RemixJS', 'NextJS'] },

	{
		categoryName: 'Data Engineering',
		list: ['Databricks', 'Spark', 'Delta Lake'],
	},
	// { }
	// 'JavaScript',
	// 'TypeScript',
	// 'SQL',
	// 'Full-stack',
	// 'Databricks',
	// 'Data Engineering',
	// 'NodeJS',
	// 'ReactJS',
	// 'Python',
]
